import { Code, HelpSection, SeeAlso, Terms } from '../prose';

/**
 * 用語集。
 *
 * 引くためのものなので、説明は 1〜2 文に切る。詳しい話は記事に置いて
 * リンクで返す。
 */
export function GlossaryArticle() {
  return (
    <>
      <HelpSection heading="組織とアカウント">
        <Terms
          rows={[
            {
              term: 'テナント',
              value:
                '契約している組織そのものです。データは組織ごとに分離されていて、他の組織のものは見えません。',
            },
            {
              term: 'ロール',
              value: (
                <>
                  {'利用者の権限です。'}
                  <Code>mcp</Code>
                  {' / '}
                  <Code>member</Code>
                  {' / '}
                  <Code>admin</Code>
                  {' の 3 段階で、そのままどちらのプランのシートを使うかも決めます。'}
                </>
              ),
            },
            {
              term: 'シート',
              value: '利用者 1 名が使う権利の単位です。招待した時点で 1 つ消費します。',
            },
            {
              term: 'PAT',
              value:
                '個人アクセストークンのことです。AI クライアントから接続するときに使います。発行した本人の記録にしか届きません。',
            },
            {
              term: 'パスキー',
              value:
                'パスワードの代わりに端末の生体認証などでログインする仕組みです。アカウントの画面から登録できます。',
            },
          ]}
        />
      </HelpSection>

      <HelpSection heading="記録と集計">
        <Terms
          rows={[
            {
              term: 'MCP',
              value: (
                <>
                  {'AI クライアントと外部サービスをつなぐ規格です。INOU では工数の記録に使います。'}
                  <SeeAlso slug="mcp-setup">MCP をつなぐ</SeeAlso>
                </>
              ),
            },
            {
              term: 'プロジェクト種別',
              value:
                '組織が自分で管理するマスタです。請求可能かどうかの既定と、直接工数として数えるかどうかを決めます。',
            },
            {
              term: 'アサイン',
              value:
                'その月に誰をどのプロジェクトに何時間充てるかの計画です。これが予定で、記録された工数が実績になります。',
            },
            {
              term: '作業カテゴリ',
              value: (
                <>
                  {'会計上の区分です。'}
                  <Code>development</Code>
                  {' / '}
                  <Code>maintenance</Code>
                  {' / '}
                  <Code>meeting</Code>
                  {' / '}
                  <Code>other</Code>
                  {' の 4 つで、AI が会話の内容から決めます。'}
                </>
              ),
            },
            {
              term: '直接工数 / 間接工数',
              value:
                '売上に直接ひもづく作業かどうかの区別です。プロジェクトの種別の設定で決まります。',
            },
            {
              term: '資産化',
              value: (
                <>
                  {
                    '開発した成果を費用ではなく資産として計上することです。プロジェクトが対象で、かつカテゴリが '
                  }
                  <Code>development</Code>
                  {' の工数だけが該当します。'}
                </>
              ),
            },
            {
              term: '予実',
              value: '予定（アサイン）と実績（記録された工数）の対比です。',
            },
            {
              term: '原価単価 / 売上単価',
              value:
                '工数を金額に置き換えるための単価です。原価単価はコスト、売上単価は請求額の計算に使います。',
            },
          ]}
        />
      </HelpSection>
    </>
  );
}
